<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
            <el-tab-pane label="用户访谈集合" name="0">
                榜单:<cooperateBank :sectionClassId="1"></cooperateBank>
                对我点赞:<cooperateLike :sectionClassId="1"></cooperateLike>
                对我评论:<cooperateDiscuss :sectionClassId="1"></cooperateDiscuss>
            </el-tab-pane>
            <el-tab-pane label="用户访谈" name="1">
                <cooperateForm :sectionClassId="1"></cooperateForm>
            </el-tab-pane>
            <el-tab-pane label="所有用户访谈" name="2">
                <cooperateFormAll :sectionClassId="1"></cooperateFormAll>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import cooperateForm from '@/components/cooperative/cooperativeForm'
    import cooperateFormAll from '@/components/cooperative/cooperativeFormAll'
    import cooperateBank from '@/components/cooperative/cooperativeBank'
    import cooperateLike from '@/components/cooperative/cooperativeLike'
    import cooperateDiscuss from '@/components/cooperative/cooperativeDiscuss'

    //定义组件
    export default {
        data() {
            return {
                activeName:'0',
                activeName1:'0',
            }
        },
        components:{
            cooperateForm,
            cooperateFormAll,
            cooperateBank,
            cooperateLike,
            cooperateDiscuss,
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/cooperative/userInterview.vue